import React, { useEffect, useRef } from 'react';
import { useLocation, useMatch } from 'react-router-dom';

import Box from '@mui/material/Box';

import FallbackComponent from 'components/ErrorBoundary/FallbackComponent';
import TopBar from 'components/TopBar';
import { useNavOverlay } from 'containers/App/Header/NavExpansionContext';

const FeatureErrorFallback = (props: React.ComponentProps<typeof FallbackComponent>): React.JSX.Element => {
  const navOverlay = useNavOverlay();
  const { key } = useLocation();
  const failedLocationKey = useRef(key);
  const isGetStartedRoute = useMatch('/get-started') !== null;
  const { clearError } = props;

  useEffect(() => {
    if (key !== failedLocationKey.current) clearError?.();
  }, [clearError, key]);

  if (!navOverlay?.compact || isGetStartedRoute) return <FallbackComponent {...props} />;

  return (
    <Box display='flex' flexDirection='column' height='100%'>
      <TopBar title='Something went wrong' />
      <Box position='relative' flex={1} minHeight={0}>
        <FallbackComponent {...props} />
      </Box>
    </Box>
  );
};

export default FeatureErrorFallback;
